export default "/images/search.svg?f9705ffe407455bd10ed6827af98d123";